<script lang="ts">
    import type {SanitizeHtmlFunction} from '../../../../../svelte/types';
    import {getContext} from 'svelte';
    import {SANITIZE_HTML_KEY} from '../../../../../svelte/utils';

    export let content;
    export let customClass = '';

    const sanitizeHtml: SanitizeHtmlFunction = getContext(SANITIZE_HTML_KEY);
</script>

<template>
    <div class="{customClass}">
        {@html sanitizeHtml(content)}
    </div>
</template>